<div class="border-radius-8 bg-white upper-section flex-1">
  <div *ngIf="inviteParticipants" class="header-section">
    <app-pencil-button
      class="pencil-button btn-back"
      *ngIf="usersToAdd.length"
      (clickEvent)="resetFilteredUsers()"
      data-name="space-manager-invite-user-back"
      icon="arrow_back"
      [iconConfig]="{ type: 'mat-icon' }"
    >
    </app-pencil-button>
    <h2 class="modal-title" mat-dialog-title>
      <div
        *ngIf="
          participantsManagerEnabled &&
          !usersToAdd.length &&
          ((totalAccessRequestsSize$ | async) ?? 0 > 0) &&
          ((requestAccessService.shouldShowAccessRequests$ | async) ||
            (waitingRoomService.shouldShowAccessRequests$ | async))
        "
        class="access-requesters-text"
        (click)="moveToAccessRequesters()"
      >
        {{ ('Requests' | translate) + ' (' + (totalAccessRequestsSize$ | async) + ')' }}
      </div>
      <span>
        {{ 'Share' | translate }}
      </span>
      <span id="space-name">
        {{ (spaceRepo.getSpace$(spaceId) | async)?.title }}
      </span>
    </h2>
    <div class="copy-close-container">
      <mat-icon
        (click)="copyEmailsFromList(addedUsers)"
        class="copy-content-icon"
        placement="bottom"
        [ngbTooltip]="copyEmailsTooltip"
        *ngIf="
          addedUsers.length > 0 &&
          isCurrentUserHost &&
          !mobileView &&
          !(addedUsers.length === 1 && addedUsers[0]._id === currentUser?._id)
        "
        >content_copy</mat-icon
      >

      <ng-template #copyEmailsTooltip>
        <app-tooltip [text]="'Copy all emails' | translate" [arrow]="'top'"></app-tooltip>
      </ng-template>
      <mat-icon
        class="material-icons-outlined close-icon"
        (click)="close()"
        data-name="space-manager-invite-user-close"
        >close</mat-icon
      >
    </div>
  </div>

  <div class="cpt-20 cpx-20 d-flex" *ngIf="freeTimeReferral">
    <mat-icon class="material-icons-outlined mr-1"> info </mat-icon>
    <div class="referral-tip-text mr-1">
      <span
        ><strong>{{ 'Useful tip' | translate }}</strong>
        {{
          ' - if you invite a user, you can both gain access to 1 month of unlimited call time!'
            | translate
        }}
      </span>
    </div>
    <app-pencil-button
      class="pencil-button medium learn-more-button"
      (clickEvent)="shareSessionReferral()"
      icon="arrow_forward"
      [iconConfig]="{ type: 'material-icon', outlined: true }"
      [label]="'Learn more' | translate"
    >
    </app-pencil-button>
  </div>

  <div *ngIf="inviteParticipants && isCurrentUserHost" class="cpt-20 cpx-20 cmb-20">
    <div class="d-flex align-items-center w-100">
      <div
        class="email-search-wrapper"
        [style.width]="usersToAdd.length ? 'calc(100% - 120px)' : '100%'"
        [style.flex]="usersToAdd.length ? '0 1 auto' : '1'"
      >
        <app-email-search
          #emailSearch
          [emails]="usersToAddEmails"
          [additionalValidators]="additionalEmailValidators"
          [suggestUsers]="true"
          [showParsedEmailChips]="true"
          [strictParsing]="false"
          [placeholder]="usersToAdd.length ? '' : ('Add People' | translate)"
          (emitEmails)="handleEmailSelection($event)"
          (emitUserselected)="handleUserSelection($event)"
          (emitBlur)="onBlurSearch()"
        ></app-email-search>
      </div>

      <div *ngIf="usersToAdd.length" class="transparent-button cml-8">
        <app-pencil-button
          [matMenuTriggerFor]="invitedRole"
          #menuTriggerRef="matMenuTrigger"
          [disabled]="!isCurrentUserHost"
          class="pencil-button user-to-invite-role"
          data-name="space-manager-invite-set-user-role"
        >
          {{ addOwnerUsers ? ('Host' | translate) : ('Participant' | translate) }}
          <mat-icon [class.open-dropdown]="menuTriggerRef.menuOpen">{{
            !menuTriggerRef.menuOpen ? 'arrow_drop_down' : 'arrow_drop_up'
          }}</mat-icon>
        </app-pencil-button>
      </div>
    </div>

    <mat-menu #invitedRole="matMenu" xPosition="before" yPosition="below" class="role-menu">
      <app-pencil-button
        class="pencil-button menu-item role-menu-item"
        (clickEvent)="changeInvitedUsersRoles(false)"
        data-name="space-manager-invite-user-role-participant"
        [selected]="!addOwnerUsers"
      >
        <div class="choice-title">
          {{ 'Participant' | translate }}
          <mat-icon *ngIf="!addOwnerUsers"> check </mat-icon>
        </div>
        <div class="choice-explanation">
          {{ 'Can edit the board and join calls' | translate }}
        </div>
      </app-pencil-button>
      <app-pencil-button
        class="pencil-button menu-item role-menu-item"
        (clickEvent)="changeInvitedUsersRoles(true)"
        data-name="space-manager-invite-user-role-host"
        [selected]="addOwnerUsers"
      >
        <div class="choice-title">
          {{ 'Host' | translate }}
          <mat-icon *ngIf="addOwnerUsers">check</mat-icon>
        </div>
        <div class="choice-explanation">
          {{ 'Can start calls, manage participants, and adjust permissions' | translate }}
        </div>
      </app-pencil-button>
    </mat-menu>

    <ng-container *ngIf="usersToAdd.length">
      <mat-checkbox
        class="cmy-8 cpl-8"
        [(ngModel)]="sendNotifyEmail"
        color="primary"
        data-name="space-manager-invite-user-notify"
      >
        {{ 'Notify people' | translate }}
      </mat-checkbox>
      <div class="invite-textarea-title">
        {{ 'Message ' | translate }}
        <span
          *ngIf="inviteText.length > inviteTextMaxLength"
          [style.color]="inviteText.length > inviteTextMaxLength ? 'red' : ''"
        >
          {{ '(Max ' + inviteTextMaxLength + ' characters)' | translate }}</span
        >
      </div>
      <textarea
        title="Message"
        class="cmb-20 cp-16 bg-light border-radius-8 w-100 font-16 invite-message-textarea"
        [style.border]="inviteText.length > inviteTextMaxLength ? '1px solid red' : ''"
        [(ngModel)]="inviteText"
      ></textarea>
      <div class="d-flex justify-content-end align-items-center">
        <app-pencil-button
          class="pencil-button medium btn-cancel cmr-8"
          (clickEvent)="close()"
          data-name="space-manager-invite-user-cancel"
          icon="close"
          [iconConfig]="{ type: 'material-icon' }"
          [label]="'Cancel' | translate"
        >
        </app-pencil-button>
        <app-pencil-button
          [disabled]="
            usersToAdd.length > 50 ||
            inviteText.length > inviteTextMaxLength ||
            (emailSearch?.emailErrorMap$ | async)?.size
          "
          (clickEvent)="submit()"
          class="pencil-button medium btn-save btn-send"
          data-name="space-manager-invite-user-send"
          icon="send"
          [iconConfig]="{ type: 'material-icon' }"
          [label]="'Send' | translate"
        >
        </app-pencil-button>
      </div>
    </ng-container>
  </div>

  <ng-template
    class="bg-white"
    #participantTemplate
    let-userInviteInfo="userInviteInfo"
    let-user="user"
  >
    <div
      class="center-no-wrap flex-1"
      (mouseenter)="hoveredUserID = user?._id"
      (mouseleave)="hoveredUserID = ''"
    >
      <img [src]="user?.profile_image" *ngIf="user?.profile_image" class="user-photo" alt="" />
      <div *ngIf="user && !user.profile_image" class="user-photo">
        {{ user?.name ? (user?.name | shortName) : (user?.email | shortName) }}
      </div>
      <div class="overflow-hidden" style="line-height: 1.4">
        <!-- Row that contains name/email + invited since + invite sent on mobile -->
        <div class="name-row d-flex align-items-center">
          <div
            class="name invited"
            [style.max-width.px]="userInviteInfo.sessionUser.joined ? '300' : ''"
          >
            {{
              user?.name
                ? (user?.name | stripWordFromString: '\\(Guest\\)')
                : isCurrentUserHost
                ? user?.email
                : (user?.email | hiddenEmail)
            }}{{ currentUser?._id === user?._id ? (' (You)' | translate) : '' }}
          </div>
          <!-- Agents (the AI tutor / a Roleplay persona) are space members so anything
               reading space.users sees them, but they are not people: mark them, and the
               email/invite-status blocks below are suppressed for them. -->
          <div class="agent-badge" *ngIf="user?.isAgent">{{ 'AI' | translate }}</div>
          <div
            class="invited-since-dot-value-container"
            *ngIf="
              !user?.isAgent &&
              !userInviteInfo.sessionUser.joined &&
              userInviteInfo.sessionUser.lastInviteTime.getTime() !== 0
            "
          >
            <div class="invited-since-dot">&bull;</div>
            <div class="invited-since">
              {{ getTimeSince(userInviteInfo.sessionUser.lastInviteTime) | translate }}
            </div>
          </div>

          <ng-container
            *ngTemplateOutlet="
              invitedStatusTemplate;
              context: {
                deviceClass: 'mobile-version',
                inviteSessionUserID: userInviteInfo.sessionUser._id
              }
            "
          >
          </ng-container>
        </div>
        <!-- Row that contains email + Copy email button -->
        <div
          class="d-flex justify-content-start align-items-center email-copy-btn-row"
          *ngIf="isCurrentUserHost && !user.isAnonymous && !user?.isAgent"
        >
          <p class="email m-0">
            {{ user?.email }}
          </p>
          <button
            (click)="copyHoveredUserEmail()"
            [hidden]="hoveredUserID !== user?._id || mobileView"
            class="btn single-email-copy"
          >
            {{ 'Copy' | translate }}
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <ng-container
      *ngTemplateOutlet="
        invitedStatusTemplate;
        context: {
          deviceClass: 'desktop-version',
          inviteSessionUserID: userInviteInfo.sessionUser._id
        }
      "
    >
    </ng-container>
    <ng-template
      #invitedStatusTemplate
      let-inviteSessionUserID="inviteSessionUserID"
      let-deviceClass="deviceClass"
    >
      <ng-container
        *ngIf="
          usersBeingRemoved.indexOf(userInviteInfo.sessionUser?._id) === -1 &&
          !userInviteInfo.sessionUser.joined
        "
      >
        <ng-template #inviteStatus>
          <span
            class="invite-status {{ deviceClass }}"
            (mouseover)="setReinviteTooltip(inviteSessionUserID)"
            (mouseleave)="setReinviteTooltip('')"
          >
            {{ 'INVITE SENT' | translate }}
          </span>
        </ng-template>
        <ng-template #reinviteButton>
          <button
            (click)="resendInviteToSingleUser(userInviteInfo.sessionUser)"
            class="btn resend-invite {{ deviceClass }}"
            (mouse)="setReinviteTooltip('')"
          >
            {{ 'Resend' | translate }}
          </button>
        </ng-template>
        <ng-container
          *ngIf="
            !isCurrentUserHost || !canReinvite(userInviteInfo.sessionUser);
            then inviteStatus;
            else reinviteButton
          "
        ></ng-container>
      </ng-container>
    </ng-template>

    <div class="center-no-wrap">
      <div
        class="transparent-button"
        *ngIf="usersBeingRemoved.indexOf(userInviteInfo.sessionUser?._id) === -1"
        [appTooltip]="spaceUserRoleTooltip"
        appTooltipPlacement="bottom-center"
        [appTooltipDisabled]="(isCurrentUserLanguageEnglish$ | async) === false"
      >
        <app-pencil-button
          [matMenuTriggerFor]="participantMenu"
          #menuTriggerRef="matMenuTrigger"
          [disabled]="editDisabledTooltipTextByUserID[userInviteInfo.sessionUser._id] !== undefined"
          class="pencil-button invited-user-role"
          [style.margin-right]="
            editDisabledTooltipTextByUserID[userInviteInfo.sessionUser._id] !== undefined
              ? '6px'
              : '0px'
          "
          data-name="space-manager-invite-user-change-user-role"
          *ngIf="hostIDs$ | async as hostsIDs"
        >
          <div>
            {{ userInviteInfo.sessionUser | sessionUserType: hostsIDs:currentSpace }}
          </div>
          <mat-icon
            [hidden]="editDisabledTooltipTextByUserID[userInviteInfo.sessionUser._id] !== undefined"
            [class.open-dropdown]="menuTriggerRef.menuOpen"
            >{{ !menuTriggerRef.menuOpen ? 'arrow_drop_down' : 'arrow_drop_up' }}</mat-icon
          >
        </app-pencil-button>
      </div>
      <ng-template #spaceUserRoleTooltip>
        <app-tooltip
          *ngIf="editDisabledTooltipTextByUserID[userInviteInfo.sessionUser._id] as text"
          [arrow]="'top'"
          [wrapText]="true"
          [text]="text"
        ></app-tooltip>
      </ng-template>
      <div
        *ngIf="usersBeingRemoved.indexOf(userInviteInfo.sessionUser?._id) !== -1"
        class="remove-user"
      >
        {{ 'REMOVE' | translate }}
      </div>

      <mat-menu #participantMenu="matMenu" xPosition="before" yPosition="below" class="role-menu">
        <app-pencil-button
          (clickEvent)="changeUserRole(userInviteInfo.sessionUser, false)"
          class="pencil-button menu-item role-menu-item"
          [selected]="!hostsIDs.has(userInviteInfo.sessionUser._id)"
          data-name="space-manager-invite-user-change-role-particpant"
          *ngIf="hostIDs$ | async as hostsIDs"
        >
          <div class="choice-title">
            {{ 'Participant' | translate }}
            <mat-icon *ngIf="!hostsIDs.has(userInviteInfo.sessionUser._id)"> check </mat-icon>
          </div>
          <div class="choice-explanation">
            {{ 'Can edit the board and join calls' | translate }}
          </div>
        </app-pencil-button>

        <app-pencil-button
          *ngIf="
            !allUsersLookup[userInviteInfo.sessionUser._id].isAnonymous &&
            (hostIDs$ | async) as hostsIDs
          "
          class="pencil-button menu-item role-menu-item"
          (clickEvent)="changeUserRole(userInviteInfo.sessionUser, true)"
          [selected]="hostsIDs.has(userInviteInfo.sessionUser._id)"
          data-name="space-manager-invite-user-change-role-host"
        >
          <div class="choice-title">
            {{ 'Host' | translate }}
            <mat-icon *ngIf="hostsIDs.has(userInviteInfo.sessionUser._id)">check</mat-icon>
          </div>
          <div class="choice-explanation">
            {{ 'Can start calls, manage participants, and adjust permissions' | translate }}
          </div>
        </app-pencil-button>

        <app-pencil-button
          class="pencil-button menu-item role-menu-item"
          (clickEvent)="onRemoveUser(userInviteInfo, true)"
          data-name="space-manager-invite-user-change-role-remove"
        >
          <div class="choice-title remove-choice">
            {{ 'Remove' | translate }}
          </div>
          <div class="choice-explanation">
            {{ "Remove this user's access to this Space" | translate }}
          </div>
        </app-pencil-button>
      </mat-menu>
    </div>
  </ng-template>

  <div
    *ngIf="inviteParticipants && !usersToAdd.length"
    class="scrollable-container wb_top_toolbar_v2_enabled"
  >
    <div
      class="participants-container cpx-20"
      [class]="{ 'no-search-box-margin': !isCurrentUserHost }"
      appIntersectionObserveElement
      #intersection="intersection"
      (isLastElementInView)="loadMoreUsers()"
    >
      <div
        class="collasible-section"
        [class.expanded]="invitedSectionExpanded && pendingInviteUsers.length"
        [hidden]="!pendingInviteUsers.length"
      >
        <div
          class="collasible-section-header section-header"
          [class.collapsed]="!invitedSectionExpanded || !pendingInviteUsers.length"
        >
          <div>
            {{
              (pendingInviteUsers.length
                | i18nPlural
                  : { '=1': 'PENDING INVITE' | translate, other: 'PENDING INVITES' | translate }) +
                ' (' +
                pendingInviteUsers.length +
                ')' | translate
            }}
          </div>

          <div class="d-flex align-items-center justify-content-center">
            <div
              (click)="copyEmailsFromList(pendingInviteUsers)"
              class="copy-invitee-emails"
              *ngIf="
                pendingInviteUsers.length > 0 &&
                isCurrentUserHost &&
                invitedSectionExpanded &&
                !mobileView &&
                !(pendingInviteUsers.length === 1 && pendingInviteUsers[0]._id === currentUser?._id)
              "
            >
              <button class="btn">{{ 'Copy emails' | translate }}</button>
              <mat-icon class="copy-content-icon">content_copy</mat-icon>
            </div>

            <mat-icon (click)="invitedSectionExpanded = !invitedSectionExpanded">{{
              invitedSectionExpanded ? 'expand_less' : 'expand_more'
            }}</mat-icon>
          </div>
        </div>
        <ng-container *ngIf="invitedSectionExpanded && pendingInviteUsers.length">
          <div class="collasible-section-body">
            <app-pencil-button
              *ngIf="pendingInviteUsers.length > 1 && isCurrentUserHost"
              class="pencil-button resend-invites-to-all share-session-btn mb-18"
              (clickEvent)="resendInviteToAllEligible()"
              [disabled]="!canReinviteOneOrMore"
              icon="forward_to_inbox"
              [iconConfig]="{ type: 'mat-icon' }"
              [label]="'Resend invites to all users' | translate"
            >
            </app-pencil-button>
            <div *ngFor="let user of pendingInviteUsers" class="participant-row">
              <div class="participant-container">
                <ng-container
                  *ngTemplateOutlet="
                    participantTemplate;
                    context: {
                      userInviteInfo: allUsersLookup[user._id].email | userInviteInfo: user,
                      user: allUsersLookup[user._id]
                    }
                  "
                >
                </ng-container>
              </div>
              <div class="cant-reinvite-tooltip">
                <app-tooltip
                  *ngIf="this.isCurrentUserHost && user._id === this.cantReinviteTooltipUserID"
                  [text]="getReinviteTooltipText(user)"
                  [arrow]="'top'"
                  [createNewLine]="true"
                ></app-tooltip>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div
        class="collasible-section"
        [class.expanded]="anonymousUserSectionExpanded && anonymousUsers.length"
        [hidden]="!anonymousUsers.length"
      >
        <div
          class="collasible-section-header section-header"
          [class.collapsed]="!anonymousUserSectionExpanded || !anonymousUsers.length"
        >
          <div>
            {{
              (anonymousUsers.length
                | i18nPlural: { '=1': 'GUEST' | translate, other: 'GUESTS' | translate }) +
                ' (' +
                anonymousUsers.length +
                ')' | translate
            }}
          </div>

          <div class="d-flex align-items-center justify-content-center">
            <mat-icon (click)="anonymousUserSectionExpanded = !anonymousUserSectionExpanded">{{
              anonymousUserSectionExpanded ? 'expand_less' : 'expand_more'
            }}</mat-icon>
          </div>
        </div>
        <ng-container *ngIf="anonymousUserSectionExpanded && anonymousUsers.length">
          <div class="collasible-section-body">
            <app-pencil-button
              *ngIf="anonymousUsers.length > 1 && isCurrentUserHost"
              class="pencil-button share-session-btn danger-no-fill mb-18"
              (clickEvent)="removeAllAnonymousUsers()"
              icon="remove_circle_outline"
              [label]="'Remove All Guests' | translate"
            >
            </app-pencil-button>
            <div *ngFor="let user of anonymousUsers" class="participant-row">
              <div class="participant-container guest-container">
                <ng-container
                  *ngTemplateOutlet="
                    participantTemplate;
                    context: {
                      userInviteInfo: allUsersLookup[user._id].email | userInviteInfo: user,
                      user: allUsersLookup[user._id]
                    }
                  "
                >
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div
        (click)="copyEmailsFromList(joinedUsers)"
        class="cmb-4 copy-participants-emails ms-auto"
        *ngIf="
          joinedUsers.length > 0 &&
          isCurrentUserHost &&
          !mobileView &&
          !(joinedUsers.length === 1 && joinedUsers[0]._id === currentUser?._id)
        "
      >
        <button class="btn">{{ 'Copy emails' | translate }}</button>
        <mat-icon class="copy-content-icon">content_copy</mat-icon>
      </div>

      <div *ngFor="let user of shownJoinedUsers$ | async; trackBy: trackById" class="d-flex w-100">
        <div class="participant-container">
          <ng-container
            *ngTemplateOutlet="
              participantTemplate;
              context: {
                userInviteInfo: allUsersLookup[user._id].email | userInviteInfo: user,
                user: allUsersLookup[user._id]
              }
            "
          >
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="usersChangingRoleIDs.size || usersBeingRemoved.length"
    class="d-flex justify-content-end align-items-center cpx-20 cmb-20"
  >
    <span class="font-12 text-gray">{{ 'Pending changes' | translate | uppercase }}</span>
    <app-pencil-button
      class="pencil-button medium cml-8 btn-save"
      [disabled]="usersToAdd.length > 50"
      (clickEvent)="saveUserRole()"
      data-name="space-manager-invite-user-save"
      icon="check"
      [iconConfig]="{ type: 'mat-icon' }"
      [label]="'Save' | translate"
    >
    </app-pencil-button>
  </div>
</div>

<div *ngIf="!usersToAdd.length" class="lower-section bg-white border-radius-8 cmt-8 cursor-pointer">
  <div class="share-link-container cmy-20">
    <div class="link-row">
      <div class="link-box">
        <div class="center-no-wrap">
          <mat-icon *ngIf="!mobileView && visibility === visibilityEnum.PRIVATE" class="lock-icon">
            lock
          </mat-icon>
          <mat-icon
            *ngIf="!mobileView && visibility === visibilityEnum.PUBLIC"
            class="lock-icon"
            [class.public]="true"
          >
            public
          </mat-icon>
          <div
            [appRestrictVisibilityControl]="currentSpace"
            [appRestrictVisibilityControlIsEnabled]="isCurrentUserHost"
            class="link-column"
          >
            <div class="transparent-button" style="margin-inline-start: 4px">
              <app-pencil-button
                [matMenuTriggerFor]="visibilityMenuComponent.menu"
                #menuTriggerRef="matMenuTrigger"
                (clickEvent)="menuTriggerRef.openMenu(); $event.stopPropagation()"
                [disabled]="!isCurrentUserHost"
                class="app-pencil-button visibility-button"
                data-name="spaces-manager-invite-user-change-access"
              >
                {{ visibility | titlecase | translate }}
                <mat-icon
                  *ngIf="isCurrentUserHost && inviteParticipants"
                  [class.open-dropdown]="menuTriggerRef.menuOpen"
                  >{{ !menuTriggerRef.menuOpen ? 'arrow_drop_down' : 'arrow_drop_up' }}</mat-icon
                >
              </app-pencil-button>
            </div>
            <div class="visibility-explanation">
              <span *ngIf="visibility === visibilityEnum.PRIVATE">
                {{ 'Users must be invited to join.' | translate }}
              </span>
              <span *ngIf="visibility === visibilityEnum.PUBLIC">
                {{ 'Anyone with link can access this Space.' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="copy-social-share-container">
        <app-pencil-button
          class="pencil-button btn-copy"
          data-name="spaces-manager-invite-user-copy"
          (clickEvent)="copyLink(); $event.stopPropagation()"
          [label]="'Copy link' | translate"
        >
        </app-pencil-button>
        <div class="vertical-divider"></div>
        <app-social-share [url]="shareLink"></app-social-share>
      </div>
    </div>
    <div
      *ngIf="visibility !== (spaceRepo.getSpace$(spaceId) | async)?.visibility"
      class="d-flex justify-content-end align-items-center cmt-20 w-100"
    >
      <span class="font-12 text-gray">{{ 'Pending changes' | translate | uppercase }}</span>
      <app-pencil-button
        color="primary"
        class="pencil-button medium cml-8 btn-save"
        (clickEvent)="changeVisibility(visibility); $event.stopPropagation()"
        data-name="spaces-manager-invite-user-share-link-save"
        icon="check"
        [iconConfig]="{ type: 'mat-icon' }"
        [label]="'Save' | translate"
      >
      </app-pencil-button>
    </div>
  </div>
</div>

<app-visibility-menu
  #visibilityMenuComponent
  [dataName]="'wb-share-session-visibility-menu-'"
  [selectedValue]="visibility"
  (valueChanged)="updateVisibilityValue($event)"
></app-visibility-menu>
